import { isHiddenProviderStatus } from '../../../utils/providerDropdownVisibility';

type ClaimProviderName = {
    FirstName?: string;
    LastName?: string;
    FullName?: string;
    Role?: { RoleName?: string } | null;
};

type ClaimProviderChoice = ClaimProviderName & {
    Id: string;
    Status?: number | null;
};

export const claimProviderChoices = <T extends ClaimProviderChoice>(providers: T[], selected?: T | null) => {
    const visible = providers.filter((provider) => !isHiddenProviderStatus(provider.Status));
    const choices = selected?.Id && !visible.some((provider) => provider.Id === selected.Id) ? [...visible, selected] : visible;

    return [...choices].sort((left, right) => {
        const byLastName = (left.LastName ?? '').localeCompare(right.LastName ?? '');
        if (byLastName !== 0) {
            return byLastName;
        }
        return (left.FirstName ?? '').localeCompare(right.FirstName ?? '');
    });
};

export const claimProviderLabel = (provider: ClaimProviderName) => {
    const name = provider.FullName || `${provider.FirstName ?? ''} ${provider.LastName ?? ''}`.trim();
    const roleName = provider.Role?.RoleName;
    return roleName ? `${name} (${roleName})` : name;
};
